module.exports = __webpack_public_path__ + "media/img/decorations/howitzer-tabs-img2-5a30d2ee44268e84b4f1ef87dea67686.svg";